// Browser translators (e.g. Chrome's Google Translate) replace text nodes with their own <font>
// wrappers, so React later tries to remove/insert relative to nodes that are no longer children of
// the parent it remembers and crashes with "Failed to execute 'removeChild' on 'Node'".
// See https://github.com/facebook/react/issues/11538
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function(child) {
    if (child.parentNode !== this) {
      // the translator moved the node; detach it from wherever it now lives instead of crashing
      if (child.parentNode) {
        return originalRemoveChild.call(child.parentNode, child);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      // the reference node was moved by the translator; append rather than throw
      return originalInsertBefore.call(this, newNode, null);
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
